import FaveBizAPI from 'integrations/FaveBizAPI';

export default params => FaveBizAPI.post(`/v1/auth`, params).then(res => res);
